import { FunctionComponent } from 'react';

import { Elements } from '@stripe/react-stripe-js';

import useCardPaymentFormWrapper from './useCardPaymentFormWrapper';

import CardPaymentFormError from '../Error';
import CardPaymentFormLoader from '../Loader';

interface CardPaymentFormWrapperProps {
  children: React.ReactNode;
}

const CardPaymentFormWrapper: FunctionComponent<
  CardPaymentFormWrapperProps
> = ({ children }) => {
  const { isLoading, showError, stripeElementsOptions, stripePromise } =
    useCardPaymentFormWrapper();

  if (isLoading) return <CardPaymentFormLoader />;

  if (showError) return <CardPaymentFormError />;

  return (
    <Elements options={stripeElementsOptions} stripe={stripePromise}>
      {children}
    </Elements>
  );
};

export default CardPaymentFormWrapper;
